import { FadeUp, Overline } from "@/components/Reveal";

const STEPS = [
  { n: "01", title: "Requirement", text: "Client specifies product, quantity and deployment." },
  { n: "02", title: "Sourcing", text: "Royal Deals FZ-LLC identifies qualifying international supply." },
  { n: "03", title: "Verification", text: "Product, documentation and commercial terms reviewed." },
  { n: "04", title: "Logistics", text: "Delivery structure and destination coordinated." },
  { n: "05", title: "Execution", text: "Hardware delivered against the agreed commercial framework." },
];

export const Process = () => (
  <section id="process" className="relative py-16 lg:py-24 bg-[#FAFAFA] border-y border-midnight/10" data-testid="process-section">
    <div className="max-w-[1400px] mx-auto px-6 lg:px-10">
      <FadeUp>
        <Overline>How We Work</Overline>
        <h2 className="font-heading text-4xl md:text-5xl font-medium tracking-tight text-midnight">
          More than hardware.
        </h2>
        <p className="text-midnight/55 text-lg mt-5 max-w-2xl">
          We help organisations secure compute.
        </p>
      </FadeUp>

      <div className="mt-16 grid grid-cols-1 md:grid-cols-5 gap-px bg-midnight/10 hairline">
        {STEPS.map((s, i) => (
          <FadeUp key={s.n} delay={i * 0.1}>
            <div className="bg-white p-8 h-full group hover:bg-[#FAFAFA] transition-colors duration-300" data-testid={`process-step-${s.n}`}>
              <p className="font-heading text-3xl font-light text-gold">{s.n}</p>
              <p className="font-heading font-medium text-midnight mt-6 mb-3">{s.title}</p>
              <p className="text-sm text-midnight/55 leading-relaxed">{s.text}</p>
            </div>
          </FadeUp>
        ))}
      </div>
    </div>
  </section>
);
